export function getPrettyFloat(value) {
  return value.toFixed(1).replace('.', ',');
}